export default "__VITE_ASSET__8e47b0a5__"